import { ExcelButton } from "@/controls/buttons/Excel-button";
import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { getMomentTz } from "@dexteel/mesf-core";
import { Grid2 as Grid, Paper, TextField } from "@mui/material";
import { AssetCard } from "../../../controls/AssetCard";
const moment = getMomentTz();

interface Props {
	onExport: () => void;
}

export const LabReportHeader = ({ onExport }: Props) => {
	const {
		state: { heatLabData, elementData },
	} = useHeatReportContext();
	const classes = useTableStyles();
	return (
		<Paper
			className={classes.borderAgGridTable}
			elevation={0}
			style={{ minWidth: "100%" }}
		>
			<Grid container spacing={2} alignItems="center" sx={{ p: 1 }}>
				{/* Column 1 */}
				<Grid size={{ xs: 12, sm: 6, md: 2 }} container>
					<Grid size={{ xs: 12 }}>
						<AssetCard assetId={15} assetName={"Lab"} />
					</Grid>
				</Grid>

				{/* Column 2 */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key="col-main-data-2"
				>
					<Grid size={{ xs: 12 }} container direction="row" spacing={1}>
						<Grid size={{ xs: 12 }}>
							<TextField
								label="Production Date"
								value={
									heatLabData?.ProductionDate
										? `${moment(heatLabData?.ProductionDate).format("MM/DD/YYYY")} - Shift ${heatLabData?.Shift} - Crew ${heatLabData?.Crew}`
										: ""
								}
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={{ xs: 12 }}>
							<TextField
								label="Sections"
								value={heatLabData?.Sections ?? ""}
								variant="outlined"
								fullWidth
							/>
						</Grid>
					</Grid>
				</Grid>
				{/* Column 3 */}
				<Grid
					size={{ xs: 12, sm: 6, md: 2 }}
					container
					spacing={1}
					key={`${heatLabData?.HeatId}-column-3`}
				>
					<Grid size={{ xs: 12 }} container direction="row" spacing={1}>
						<Grid size={{ xs: 12 }}>
							<TextField
								label="Programmed Grade"
								value={heatLabData?.ProgrammedGrade ?? ""}
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={{ xs: 12 }}>
							<TextField
								label="Cast Grade"
								value={heatLabData?.Grade ?? ""}
								variant="outlined"
								fullWidth
								InputProps={{
									style: {
										color: heatLabData?.Grade
											? heatLabData?.Grade !== heatLabData?.ProgrammedGrade
												? "red"
												: "black"
											: "black",
									},
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid
					size={{ xs: "grow" }}
					container
					justifyContent="flex-end"
					alignItems="center"
				>
					<ExcelButton
						onClick={onExport}
						disabled={!elementData || elementData.length === 0}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
